import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";


import COMMONS_IT from "./Components/Common/locales/it.json"
import COMMONS_EN from "./Components/Common/locales/en.json"
import USERS_IT from "./pages/User/locales/it.json"
import USERS_EN from "./pages/User/locales/en.json"
import PROFILE_IT from "./pages/Profile/Settings/locales/it.json"
import PROFILE_EN from "./pages/Profile/Settings/locales/en.json"
import NOTIFICATIONS_IT from "./pages/Notifications/locales/it.json"
import NOTIFICATIONS_EN from "./pages/Notifications/locales/en.json"
import LAYOUT_IT from "./Layouts/locales/it.json"
import LAYOUT_EN from "./Layouts/locales/en.json"
import FILE_MANAGER_IT from "./pages/FileManager/locales/it.json"
import FILE_MANAGER_EN from "./pages/FileManager/locales/en.json"
import CHAT_IT from "./pages/Chat/locales/it.json"
import CHAT_EN from "./pages/Chat/locales/en.json"

// the translations
const resources = {
  it: {
    translation: {
      COMMONS: COMMONS_IT,
      USERS: USERS_IT,
      FILE_MANAGER: FILE_MANAGER_IT,
      PROFILE: PROFILE_IT,
      NOTIFICATIONS: NOTIFICATIONS_IT,
      LAYOUT: LAYOUT_IT,
      CHAT: CHAT_IT,
    },
  },
  en: {
    translation: {
      COMMONS: COMMONS_EN,
      USERS: USERS_EN,
      FILE_MANAGER: FILE_MANAGER_EN,
      PROFILE: PROFILE_EN,
      NOTIFICATIONS: NOTIFICATIONS_EN,
      LAYOUT: LAYOUT_EN,
      CHAT: CHAT_EN,
    },
  },
};

const language = localStorage.getItem("I18N_LANGUAGE");
if (!language) {
  localStorage.setItem("I18N_LANGUAGE", "it");
}

i18n
  .use(detector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: localStorage.getItem("I18N_LANGUAGE") || "it",
    fallbackLng: "it", // use en if detected lng is not available

    keySeparator: ":", // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
